import { BettoProviderIcon } from "@layouts/betto/providers/BettoProviderIcon";
import React from "react";

import { BettoProviderLogoWrap } from "./elements";

export const BettoProviderLogo = ({ provider }) => (
	<BettoProviderLogoWrap>
		<BettoProviderIcon name={provider} />
	</BettoProviderLogoWrap>
);
